/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierUserChangePasswordRequest
 */
export interface CourierUserChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierUserChangePasswordRequest
     */
    oldPassword: string;
    /**
     * 
     * @type {string}
     * @memberof CourierUserChangePasswordRequest
     */
    newPassword: string;
}

/**
 * Check if a given object implements the CourierUserChangePasswordRequest interface.
 */
export function instanceOfCourierUserChangePasswordRequest(value: object): value is CourierUserChangePasswordRequest {
    if (!('oldPassword' in value) || value['oldPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function CourierUserChangePasswordRequestFromJSON(json: any): CourierUserChangePasswordRequest {
    return CourierUserChangePasswordRequestFromJSONTyped(json, false);
}

export function CourierUserChangePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUserChangePasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'],
        'newPassword': json['newPassword'],
    };
}

export function CourierUserChangePasswordRequestToJSON(json: any): CourierUserChangePasswordRequest {
    return CourierUserChangePasswordRequestToJSONTyped(json, false);
}

export function CourierUserChangePasswordRequestToJSONTyped(value?: CourierUserChangePasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldPassword': value['oldPassword'],
        'newPassword': value['newPassword'],
    };
}

